export default (el, { expression }, { evaluate }) => {
    const countTo = evaluate(expression);
    let start = 0;
    const end = countTo.count || 1;
    const duration = 1500;
    const stepTime = Math.abs(Math.floor(duration / end));
    const easeOutQuad = t => t * (2 - t);
    let animationStarted = false;
    let startTime = performance.now();
    const animateCountUp = (time) => {
        const t = Math.min(1, ((time - startTime) / duration));
        const easedT = easeOutQuad(t);
        el.textContent = Math.floor(easedT * end) + countTo.suffix;
        if (t < 1) {
            requestAnimationFrame(animateCountUp);
        }
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting && !animationStarted) {
                animationStarted = true;
                startTime = performance.now();
                requestAnimationFrame(animateCountUp);
            } else {
              animationStarted = false;
              el.textContent = 0 + countTo.suffix;
            }
        });
    }, { threshold: 0.1 });

  observer.observe(el);
};
